import {
    FETCH_TRAINING_PLANS_FETCHING,
    FETCH_TRAINING_PLANS_SUCCESS,
    FETCH_TRAINING_PLANS_FAIL,
    FETCH_SELF_GUIDED_PLAN_FETCHING,
    FETCH_SELF_GUIDED_PLAN_SUCCESS,
    FETCH_SELF_GUIDED_PLAN_FAIL,
    FETCH_ALL_SELF_GUIDED_PLAN_FETCHING,
    FETCH_ALL_SELF_GUIDED_PLAN_SUCCESS,
    FETCH_ALL_SELF_GUIDED_PLAN_FAIL,
    FETCH_ACTIVE_PLANS_FETCHING,
    FETCH_ACTIVE_PLANS_SUCCESS,
    FETCH_ACTIVE_PLANS_FAIL,
    RESET_ACTIVE_PLANS
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    trainingPlans: {
        entities: {},
        isFetching: {},
        fetchFailed: {}
    },
    selfGuidedPlans: {
        plans: {},
        isFetching: {},
        fetchFailed: {}
    },
    allSelfGuidedPlans: {
        plans: [],
        isFetching: false,
        fetchFailed: false
    },
    activePlans: {
        plans: [],
        isFetching: false,
        fetchFailed: false,
        fetchSuccess: false
    }
};

const fetchTrainingPlansFetching = (state, action) => {
    return {
        ...state,
        trainingPlans: {
            ...state.trainingPlans,
            entities: {
                ...state.trainingPlans.entities
            },
            isFetching: {
                ...state.isFetching,
                [action.activityType]: true
            },
            fetchFailed: {
                ...state.fetchFailed,
                [action.activityType]: false
            }
        }
    };
};

const fetchTrainingPlansSuccess = (state, action) => {
    return {
        ...state,
        trainingPlans: {
            ...state.trainingPlans,
            entities: {
                ...state.trainingPlans.entities,
                [action.activityType]: action.trainingPlans
            },
            isFetching: {
                ...state.isFetching,
                [action.activityType]: false
            },
            fetchFailed: {
                ...state.fetchFailed,
                [action.activityType]: false
            }
        }
    };
};

const fetchTrainingPlansError = (state, action) => {
    return {
        ...state,
        trainingPlans: {
            ...state.trainingPlans,
            entities: {
                ...state.trainingPlans.entities,
                [action.trainingPlanId]: {}
            },
            isFetching: {
                ...state.isFetching,
                [action.trainingPlanId]: false
            },
            fetchFailed: {
                ...state.fetchFailed,
                [action.trainingPlanId]: true
            }
        }
    };
};

const fetchSelfGuidedPlanFetching = (state, action) => {
    return {
        ...state,
        selfGuidedPlans: {
            ...state.selfGuidedPlans,
            plans: {
                ...state.selfGuidedPlans.plans
            },
            isFetching: {
                ...state.isFetching,
                [action.trainingPlanId]: true
            },
            fetchFailed: {
                ...state.fetchFailed,
                [action.trainingPlanId]: false
            }
        }
    };
};

const fetchSelfGuidedPlanSuccess = (state, action) => {
    return {
        ...state,
        selfGuidedPlans: {
            ...state.selfGuidedPlans,
            plans: {
                ...state.selfGuidedPlans.plans,
                [action.trainingPlanId]: action.trainingPlans
            },
            isFetching: {
                ...state.isFetching,
                [action.trainingPlanId]: false
            },
            fetchFailed: {
                ...state.fetchFailed,
                [action.trainingPlanId]: false
            }
        }
    };
};

const fetchSelfGuidedPlanError = (state, action) => {
    return {
        ...state,
        selfGuidedPlans: {
            ...state.selfGuidedPlans,
            plans: {
                ...state.plans,
                [action.trainingPlanId]: {}
            },
            isFetching: {
                ...state.isFetching,
                [action.trainingPlanId]: false
            },
            fetchFailed: {
                ...state.fetchFailed,
                [action.trainingPlanId]: true
            }
        }
    };
};

const fetchAllSelfGuidedPlanFetching = (state, action) => {
    return {
        ...state,
        allSelfGuidedPlans: {
            ...state.allSelfGuidedPlans,
            plans: [],
            isFetching: true,
            fetchFailed: false
        }
    };
};

const fetchAllSelfGuidedPlanSuccess = (state, action) => {
    return {
        ...state,
        allSelfGuidedPlans: {
            ...state.allSelfGuidedPlans,
            plans: action.trainingPlans,
            isFetching: false,
            fetchFailed: false
        }
    };
};

const fetchAllSelfGuidedPlanError = (state, action) => {
    return {
        ...state,
        allSelfGuidedPlans: {
            ...state.allSelfGuidedPlans,
            plans: [],
            isFetching: false,
            fetchFailed: true
        }
    };
};

const fetchActivePlansFetching = (state, action) => {
    return {
        ...state,
        activePlans: {
            plans: [],
            isFetching: true,
            fetchFailed: false,
            fetchSuccess: false
        }
    };
};

const fetchActivePlansSuccess = (state, action) => {
    let activePlans = action.trainingPlans.filter((plan) => {
        return ['Active', 'Scheduled'].includes(plan.trainingStatus.statusKey);
    });
    return {
        ...state,
        activePlans: {
            ...state.activePlans,
            plans: activePlans,
            isFetching: false,
            fetchFailed: false,
            fetchSuccess: true
        }
    };
};

const fetchActivePlansError = (state, action) => {
    return {
        ...state,
        activePlans: {
            plans: [],
            isFetching: false,
            fetchFailed: true,
            fetchSuccess: false
        }
    };
};

const resetActivePlans = (state) => {
    return {
        ...state,
        activePlans: {
            plans: [],
            isFetching: false,
            fetchFailed: false,
            fetchSuccess: false
        }
    };
};

const handlers = {
    [FETCH_TRAINING_PLANS_FETCHING]: fetchTrainingPlansFetching,
    [FETCH_TRAINING_PLANS_SUCCESS]: fetchTrainingPlansSuccess,
    [FETCH_TRAINING_PLANS_FAIL]: fetchTrainingPlansError,
    [FETCH_SELF_GUIDED_PLAN_FETCHING]: fetchSelfGuidedPlanFetching,
    [FETCH_SELF_GUIDED_PLAN_SUCCESS]: fetchSelfGuidedPlanSuccess,
    [FETCH_SELF_GUIDED_PLAN_FAIL]: fetchSelfGuidedPlanError,
    [FETCH_ALL_SELF_GUIDED_PLAN_FETCHING]: fetchAllSelfGuidedPlanFetching,
    [FETCH_ALL_SELF_GUIDED_PLAN_SUCCESS]: fetchAllSelfGuidedPlanSuccess,
    [FETCH_ALL_SELF_GUIDED_PLAN_FAIL]: fetchAllSelfGuidedPlanError,
    [FETCH_ACTIVE_PLANS_FETCHING]: fetchActivePlansFetching,
    [FETCH_ACTIVE_PLANS_SUCCESS]: fetchActivePlansSuccess,
    [FETCH_ACTIVE_PLANS_FAIL]: fetchActivePlansError,
    [RESET_ACTIVE_PLANS]: resetActivePlans
};

export default function trainingPlanIntegration(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const isTrainingPlanFetching = (state, activityType) => {
    return state.trainingPlanIntegration.trainingPlans.isFetching
        ? state.trainingPlanIntegration.trainingPlans.isFetching[activityType]
        : false;
};

export const isTrainingPlanFail = (state, activityType) => {
    return state.trainingPlanIntegration.trainingPlans.fetchFailed
        ? state.trainingPlanIntegration.trainingPlans.fetchFailed[activityType]
        : false;
};

export const getTrainingPlans = (state, activityType) => {
    return state.trainingPlanIntegration.trainingPlans.entities[activityType];
};

export const isSelfGuidedPlanFetching = (state, trainingPlanId) => {
    return state.trainingPlanIntegration.selfGuidedPlans.isFetching
        ? state.trainingPlanIntegration.selfGuidedPlans.isFetching[trainingPlanId]
        : false;
};

export const isSelfGuidedFail = (state, trainingPlanId) => {
    return state.trainingPlanIntegration.selfGuidedPlans.fetchFailed
        ? state.trainingPlanIntegration.selfGuidedPlans.fetchFailed[trainingPlanId]
        : false;
};

export const getSelfGuidedPlan = (state, trainingPlanId) => {
    return state.trainingPlanIntegration.selfGuidedPlans.plans[trainingPlanId];
};

export const isAllTrainingPlansFetching = (state) => {
    return state.trainingPlanIntegration?.allSelfGuidedPlans?.isFetching;
};

export const isAllTrainingPlansFail = (state) => {
    return state.trainingPlanIntegration?.allSelfGuidedPlans?.fetchFailed;
};

export const getAllTrainingPlans = (state) => {
    return state.trainingPlanIntegration?.allSelfGuidedPlans?.plans || [];
};

export const isActivePlansFetching = (state) => {
    return state.trainingPlanIntegration.activePlans.isFetching;
};

export const isActivePlansFail = (state) => {
    return state.trainingPlanIntegration.activePlans.fetchFailed;
};

export const isActivePlansSuccess = (state) => {
    return state.trainingPlanIntegration.activePlans.fetchSuccess;
};

export const getActivePlans = (state) => {
    return state.trainingPlanIntegration.activePlans.plans || [];
};
